import { TIER_BADGE_CLASS } from '@/types/profiler';
import type { RiskTier } from '@/types/profiler';

interface Props {
  tier: RiskTier;
  pulse?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

const SIZE = {
  sm: 'px-2 py-0.5 text-[9px]',
  md: 'px-2.5 py-1 text-[10px]',
  lg: 'px-3 py-1.5 text-xs',
};

export function RiskTierBadge({ tier, pulse = false, size = 'md' }: Props) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full font-bold tracking-widest font-mono ${SIZE[size]} ${TIER_BADGE_CLASS[tier]}`}
    >
      {pulse && tier === 'CRITICAL' && (
        <span className="relative flex h-1.5 w-1.5">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" />
          <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-red-500" />
        </span>
      )}
      {tier}
    </span>
  );
}
